module.exports = __webpack_public_path__ + "b8146c3163fed67e5c3272b6d22c48d7.png";